// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `section {
    flex: 1 0 auto;
    position: relative;
    width: 100%;
    transition: all .5s ease-in;
}

.who_am_I {
    font-family: Cinzel;
}

.has-first-color {
    color: var(--primary-color);
}

.btn-portfolio {
    background: var(--primary-color);
    border-radius: 0;
}

.btn-portfolio a {
    color: #000;
    text-decoration: none;
}

.btn-about a {
    color: var(--text-color);
    text-decoration: none;
}

.intro_sec {
    height: calc(100vh - 60px);
    min-height: 700px;
    height: 100vh;
    margin-top: -60px;
}

@media (max-width:991.98px) {
    .intro_sec {
        display: block;
        height: auto!important;
    }
}

.intro_sec .text,
.intro_sec .h_bg-image {
    width: 50%;
}

@media (max-width:991.98px) {
    .intro_sec .text,
    .intro_sec .h_bg-image {
        width: 100%;
    }
}

.intro_sec .intro {
    max-width: 450px;
    margin: 0 auto;
}

@media (max-width:991.98px) {
    .intro_sec .intro {
        max-width: 700px;
        padding-left: 20px;
        padding-right: 20px;
    }
}

.intro_sec .intro .feature .wrap-icon {
    background: 0 0!important;
    width: auto;
    height: auto;
    margin-bottom: 0;
}

.intro_sec .intro .feature .wrap-icon svg {
    color: #5cccc9;
}

.intro_sec .text h1 {
    font-size: 30px;
    margin-bottom: 50px;
    font-weight: 700;
}

.intro_sec .text h3 {
    font-size: 16px;
    font-weight: 700;
}

.intro_sec .h_bg-image {
    background-size: cover;
    background-position: center;
    min-height: 700px;
    position: relative;
}

.ac_btn {
    padding: 4px 19px;
    color: var(--secondary-color);
    position: relative;
    border: var(--secondary-color) 2px solid;
    overflow: hidden;
    transition: all 0.6s cubic-bezier(0.55, 0, 0.1, 1);
    cursor: pointer;
    border-radius: 0;
    margin-right: 20px;
}

.ac_btn a {
    text-decoration: none;
}

.ac_btn:hover {
    box-shadow: 8px 8px 0px var(--text-color), -8px -8px 0px var(--text-color);
}

.ac_btn:hover .one {
    opacity: 1;
    transform: translate3d(0px, 0px, 0px);
}

.ac_btn:hover .two {
    transform: translate3d(0px, 0px, 0px);
}

.ac_btn:hover .three {
    transform: translate3d(0px, 0px, 0px);
}

.ac_btn:hover .four {
    transform: translate3d(0px, 0px, 0px);
}

.ac_btn .ring {
    width: 100%;
    height: 100%;
    position: absolute;
    background: transparent;
    top: 0;
    left: 0;
    transform: translate3d(0px, 90px, 0px);
}

.ac_btn .one {
    background-color: #000;
    transition: all 0.3s cubic-bezier(0.55, 0, 0.1, 1);
    z-index: -3;
    z-index: -4;
}

.ac_btn .two {
    background-color: var(--primary-color);
    transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
    z-index: -3;
}

.ac_btn .three {
    background-color: var(--secondary-color);
    z-index: -2;
    transition: all 0.7s cubic-bezier(0.55, 0, 0.1, 1);
    z-index: -3;
}

#button_p {
    background: var(--secondary-color);
    color: var(--primary-color);
}

#button_h:hover {
    color: var(--primary-color)
}

.intro_sec .h_bg-image .block {
    bottom: 50vh;
    max-width: 220px;
    padding: 30px;
    left: -110px;
    position: absolute;
    width: 250px;
    height: 220px;
    border-radius: 100%;
    /* mix-blend-mode: multiply; */
    background-color: #2f514e;
    z-index: 9999999999;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
}

@media (max-width:991.98px) {
    .intro_sec .h_bg-image {
        height: 600px;
        min-height: 75vh;
        margin-bottom: 30px;
    }
    .intro_sec .h_bg-image .block {
        top: unset;
        bottom: 0;
        width: 100%;
        margin: 0;
        left: 50%;
        transform: translate(-50%, 50%);
    }
}

.intro_sec .h_bg-image .block .wrap-icon {
    font-size: 40px;
    color: var(--text-color);
    margin-bottom: 10px;
    display: block;
}

.intro_sec .h_bg-image .block h3 {
    font-size: 14px;
    color: var(--text-color);
    letter-spacing: .1rem;
    font-weight: 700;
    margin-bottom: 15px;
}

.intro_sec .h_bg-image .block p {
    font-size: 14px;
    line-height: 1.3;
    color: var(--text-color)
}

.intro_sec .h_bg-image {
    filter: saturate(0.5);
}`, "",{"version":3,"sources":["webpack://./src/pages/home/style.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IAGX,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,sBAAsB;IAC1B;AACJ;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI;;QAEI,WAAW;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI;QACI,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;IAC7B,kBAAkB;IAClB,wCAAwC;IACxC,gBAAgB;IAChB,kDAAkD;IAClD,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,0EAA0E;AAC9E;;AAEA;IACI,UAAU;IACV,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,MAAM;IACN,OAAO;IACP,sCAAsC;AAC1C;;AAEA;IACI,sBAAsB;IACtB,kDAAkD;IAClD,WAAW;IACX,WAAW;AACf;;AAEA;IACI,sCAAsC;IACtC,kDAAkD;IAClD,WAAW;AACf;;AAEA;IACI,wCAAwC;IACxC,WAAW;IACX,kDAAkD;IAClD,WAAW;AACf;;AAEA;IACI,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI;QACI,aAAa;QACb,gBAAgB;QAChB,mBAAmB;IACvB;IACA;QACI,UAAU;QACV,SAAS;QACT,WAAW;QACX,SAAS;QACT,SAAS;QACT,+BAA+B;IACnC;AACJ;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":["section {\n    flex: 1 0 auto;\n    position: relative;\n    width: 100%;\n    -webkit-transition: all .5s ease-in;\n    -o-transition: all .5s ease-in;\n    transition: all .5s ease-in;\n}\n\n.who_am_I {\n    font-family: Cinzel;\n}\n\n.has-first-color {\n    color: var(--primary-color);\n}\n\n.btn-portfolio {\n    background: var(--primary-color);\n    border-radius: 0;\n}\n\n.btn-portfolio a {\n    color: #000;\n    text-decoration: none;\n}\n\n.btn-about a {\n    color: var(--text-color);\n    text-decoration: none;\n}\n\n.intro_sec {\n    height: calc(100vh - 60px);\n    min-height: 700px;\n    height: 100vh;\n    margin-top: -60px;\n}\n\n@media (max-width:991.98px) {\n    .intro_sec {\n        display: block;\n        height: auto!important;\n    }\n}\n\n.intro_sec .text,\n.intro_sec .h_bg-image {\n    width: 50%;\n}\n\n@media (max-width:991.98px) {\n    .intro_sec .text,\n    .intro_sec .h_bg-image {\n        width: 100%;\n    }\n}\n\n.intro_sec .intro {\n    max-width: 450px;\n    margin: 0 auto;\n}\n\n@media (max-width:991.98px) {\n    .intro_sec .intro {\n        max-width: 700px;\n        padding-left: 20px;\n        padding-right: 20px;\n    }\n}\n\n.intro_sec .intro .feature .wrap-icon {\n    background: 0 0!important;\n    width: auto;\n    height: auto;\n    margin-bottom: 0;\n}\n\n.intro_sec .intro .feature .wrap-icon svg {\n    color: #5cccc9;\n}\n\n.intro_sec .text h1 {\n    font-size: 30px;\n    margin-bottom: 50px;\n    font-weight: 700;\n}\n\n.intro_sec .text h3 {\n    font-size: 16px;\n    font-weight: 700;\n}\n\n.intro_sec .h_bg-image {\n    background-size: cover;\n    background-position: center;\n    min-height: 700px;\n    position: relative;\n}\n\n.ac_btn {\n    padding: 4px 19px;\n    color: var(--secondary-color);\n    position: relative;\n    border: var(--secondary-color) 2px solid;\n    overflow: hidden;\n    transition: all 0.6s cubic-bezier(0.55, 0, 0.1, 1);\n    cursor: pointer;\n    border-radius: 0;\n    margin-right: 20px;\n}\n\n.ac_btn a {\n    text-decoration: none;\n}\n\n.ac_btn:hover {\n    box-shadow: 8px 8px 0px var(--text-color), -8px -8px 0px var(--text-color);\n}\n\n.ac_btn:hover .one {\n    opacity: 1;\n    transform: translate3d(0px, 0px, 0px);\n}\n\n.ac_btn:hover .two {\n    transform: translate3d(0px, 0px, 0px);\n}\n\n.ac_btn:hover .three {\n    transform: translate3d(0px, 0px, 0px);\n}\n\n.ac_btn:hover .four {\n    transform: translate3d(0px, 0px, 0px);\n}\n\n.ac_btn .ring {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    background: transparent;\n    top: 0;\n    left: 0;\n    transform: translate3d(0px, 90px, 0px);\n}\n\n.ac_btn .one {\n    background-color: #000;\n    transition: all 0.3s cubic-bezier(0.55, 0, 0.1, 1);\n    z-index: -3;\n    z-index: -4;\n}\n\n.ac_btn .two {\n    background-color: var(--primary-color);\n    transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);\n    z-index: -3;\n}\n\n.ac_btn .three {\n    background-color: var(--secondary-color);\n    z-index: -2;\n    transition: all 0.7s cubic-bezier(0.55, 0, 0.1, 1);\n    z-index: -3;\n}\n\n#button_p {\n    background: var(--secondary-color);\n    color: var(--primary-color);\n}\n\n#button_h:hover {\n    color: var(--primary-color)\n}\n\n.intro_sec .h_bg-image .block {\n    bottom: 50vh;\n    max-width: 220px;\n    padding: 30px;\n    left: -110px;\n    position: absolute;\n    width: 250px;\n    height: 220px;\n    border-radius: 100%;\n    /* mix-blend-mode: multiply; */\n    background-color: #2f514e;\n    z-index: 9999999999;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n}\n\n@media (max-width:991.98px) {\n    .intro_sec .h_bg-image {\n        height: 600px;\n        min-height: 75vh;\n        margin-bottom: 30px;\n    }\n    .intro_sec .h_bg-image .block {\n        top: unset;\n        bottom: 0;\n        width: 100%;\n        margin: 0;\n        left: 50%;\n        transform: translate(-50%, 50%);\n    }\n}\n\n.intro_sec .h_bg-image .block .wrap-icon {\n    font-size: 40px;\n    color: var(--text-color);\n    margin-bottom: 10px;\n    display: block;\n}\n\n.intro_sec .h_bg-image .block h3 {\n    font-size: 14px;\n    color: var(--text-color);\n    letter-spacing: .1rem;\n    font-weight: 700;\n    margin-bottom: 15px;\n}\n\n.intro_sec .h_bg-image .block p {\n    font-size: 14px;\n    line-height: 1.3;\n    color: var(--text-color)\n}\n\n.intro_sec .h_bg-image {\n    filter: saturate(0.5);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
